import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { GridRowModel } from '@mui/x-data-grid'

/* Derived from https://mui.com/x/react-data-grid/editing/ */
export default function EditCellConfirmationDialog(
  props: IEditCellConfirmationDialog
) {
  const {
    promiseArguments,
    setPromiseArguments,
    confirmationMessage,
    dialogConfirmation
  } = props

  const [dialogText, setDialogText] = useState<string>('')

  useEffect(() => {
    if (!promiseArguments) {
      return
    }

    const { newRow, oldRow } = promiseArguments
    setDialogText(confirmationMessage(newRow, oldRow))
  }, [promiseArguments])

  const handleNo = () => {
    if (promiseArguments) {
      const { oldRow, resolve } = promiseArguments
      resolve(oldRow)
      setPromiseArguments(null)
    }
  }

  return (
    <Dialog maxWidth='xs' open={!!promiseArguments}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent dividers>{dialogText}</DialogContent>
      <DialogActions>
        <Button onClick={handleNo}>No</Button>
        <Button onClick={dialogConfirmation}>Yes</Button>
      </DialogActions>
    </Dialog>
  )
}

interface IEditCellConfirmationDialog {
  promiseArguments?: IPromiseArguments | null
  setPromiseArguments: (arg?: IPromiseArguments | null) => void
  dialogTitle: string
  dialogConfirmation: () => void
  confirmationMessage: (oldRow: GridRowModel, newRow: GridRowModel) => string
}

interface IPromiseArguments {
  newRow: GridRowModel
  oldRow: GridRowModel
  resolve: (row: GridRowModel) => void
  reject: (row: GridRowModel) => void
}
